'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var reactIntl = require('react-intl');
var Highcharts = _interopDefault(require('highcharts'));
var HighchartsReact = _interopDefault(require('highcharts-react-official'));
var LoadingSpinner = require('../../LoadingSpinner/LoadingSpinner.js');
var utils = require('./utils.js');

var LineChart = function (props) {
    var goal = props.goal, method = props.method, data = props.data, name = props.name, lineColorOverride = props.lineColorOverride, xAxisData = props.xAxisData, autoRotationOverride = props.autoRotationOverride, goalColorOverride = props.goalColorOverride, colorOverride = props.colorOverride, yAxisAddon = props.yAxisAddon, _a = props.hasLegend, hasLegend = _a === void 0 ? true : _a, height = props.height, goalNameOverride = props.goalNameOverride, tickPositions = props.tickPositions, hasGridLine = props.hasGridLine, threshold = props.threshold, gradientOverride = props.gradientOverride, _b = props.yAxisTitle, yAxisTitle = _b === void 0 ? null : _b, tooltipFormatter = props.tooltipFormatter, // https://api.highcharts.com/highcharts/tooltip
    _c = props.yAxisLabels, // https://api.highcharts.com/highcharts/tooltip
    yAxisLabels = _c === void 0 ? true : _c, _d = props.xAxisLabelRotation, xAxisLabelRotation = _d === void 0 ? -45 : _d, _e = props.loading, loading = _e === void 0 ? false : _e;
    var theme = core.useTheme();
    var fm = reactIntl.useIntl().formatMessage;
    var series = [
        utils.generateDataSeries(data, name, lineColorOverride),
        utils.generateGoalSeries(theme, data.length, goalNameOverride !== null && goalNameOverride !== void 0 ? goalNameOverride : fm({ id: 'componentLib.appWide.goal' }), goal, method, goalColorOverride),
    ].filter(function (x) { return !!x.data; }); // eslint-disable-line @typescript-eslint/no-explicit-any
    var options = utils.generateOptions({
        hasLegend: hasLegend,
        height: height,
        threshold: threshold,
        gradientOverride: gradientOverride,
        series: series,
        tooltipFormatter: tooltipFormatter,
        xAxisData: xAxisData,
        autoRotationOverride: autoRotationOverride,
        colorOverride: colorOverride,
        hasGridLine: hasGridLine,
        xAxisLabelRotation: xAxisLabelRotation,
        yAxisTitle: yAxisTitle,
        yAxisLabels: yAxisLabels,
        yAxisAddon: yAxisAddon,
        tickPositions: tickPositions,
    });
    return (React__default.createElement(LoadingSpinner, { isLoading: loading },
        React__default.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};

module.exports = LineChart;
